/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserIsAlertRecipientByDefaultQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserIsAlertRecipientByDefaultQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly isAlertRecipientByDefault: boolean, readonly legacyId: string } | null };


export const UserIsAlertRecipientByDefaultDocument = gql`
    query UserIsAlertRecipientByDefault($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    isAlertRecipientByDefault
    legacyId
  }
}
    `;

/**
 * __useUserIsAlertRecipientByDefaultQuery__
 *
 * To run a query within a React component, call `useUserIsAlertRecipientByDefaultQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIsAlertRecipientByDefaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIsAlertRecipientByDefaultQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserIsAlertRecipientByDefaultQuery(baseOptions: Apollo.QueryHookOptions<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables> & ({ variables: UserIsAlertRecipientByDefaultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>(UserIsAlertRecipientByDefaultDocument, options);
      }
export function useUserIsAlertRecipientByDefaultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>(UserIsAlertRecipientByDefaultDocument, options);
        }
export function useUserIsAlertRecipientByDefaultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>(UserIsAlertRecipientByDefaultDocument, options);
        }
export type UserIsAlertRecipientByDefaultQueryHookResult = ReturnType<typeof useUserIsAlertRecipientByDefaultQuery>;
export type UserIsAlertRecipientByDefaultLazyQueryHookResult = ReturnType<typeof useUserIsAlertRecipientByDefaultLazyQuery>;
export type UserIsAlertRecipientByDefaultSuspenseQueryHookResult = ReturnType<typeof useUserIsAlertRecipientByDefaultSuspenseQuery>;
export type UserIsAlertRecipientByDefaultQueryResult = Apollo.QueryResult<UserIsAlertRecipientByDefaultQuery, UserIsAlertRecipientByDefaultQueryVariables>;